<template>
  <v-container
    id="productTemplateDetailTab"
    class="pa-0"
  >
    <base-resource-grid
      ref="resourceGrid"
      color="blue-grey"
      icon="mdi-help"
      plural-name="Details"
      singular-name="Detail"
      allow-expand
      :headers="gridHeaders"
      :resource="productTemplateDetailResource"
      :fetch-method="getProductTemplateDetail"
      :custom-columns="customColumns"
      :actions="actions"
      :prepare-save="prepareSave"
      :sort-by="['sectionOrderNo', 'orderNo']"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
    >
      <template v-slot:gridInteractions>
        <base-resource-select
          :key="sectionChangeKey"
          label="Filter By Section"
          item-text="templateSection"
          item-value="id"
          bind-text="templateSection"
          bind-value="productTemplateSectionId"
          :bind-item="selectedSection"
          :fetch-method="getSections"
          @change="filtersChanged"
        />
      </template>
      <template
        v-slot:item.answerRequired="{ item }"
      >
        {{ item.answerRequired ? 'Yes' : 'No' }}
      </template>
      <template
        v-slot:editForm="bindings"
        class="pa-0"
      >
        <product-template-detail-edit
          v-model="bindings.editedItem"
          class="pa-0"
          :form-errors="bindings.formErrors"
          :product-template-id="productTemplateId"
          :default-section-id="selectedSectionId"
        />
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="productTemplateDetailHistory/"
      id-field="productTemplateDetailId"
      title-field="ProductTemplateDetail"
      color="blue-grey"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import { ensureNumericOrNull } from '@/services/Sanitizers'

  export default {
    name: 'ProductTemplateDetailTab',

    components: {
      ProductTemplateDetailEdit: () => import('./ProductTemplateDetailEdit'),
    },

    props: {
      productTemplateId: {
        type: Number,
        default: null,
      },
      sectionChangeKey: {
        type: Number,
        default: null,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      customColumns: [
        'answerRequired',
      ],

      gridHeaders: [
        {
          text: 'Section',
          value: 'templateSection',
        },
        {
          text: 'Question',
          value: 'question',
        },
        {
          text: 'Required',
          value: 'answerRequired',
          dataType: 'boolean',
        },
        {
          text: 'Order',
          value: 'orderNo',
        },
      ],

      historyColumns: [
        {
          text: 'Question',
          value: 'question',
        },
        {
          text: 'Data Type',
          value: 'answerDataType',
        },
        {
          text: 'Required',
          value: 'answerRequired',
          dataType: 'boolean',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      selectedSection: {},
      selectedSectionId: null,

      productTemplateDetailResource: new TroodyApi('productTemplateDetail/'),
      productTemplateSectionResource: new TroodyApi('productTemplateSection/'),

      historyItem: null,
    }),

    methods: {
      getSections () {
        return this.productTemplateSectionResource.query({ productTemplateId: this.productTemplateId })
      },

      filtersChanged () {
        this.selectedSectionId = (this.selectedSection.productTemplateSectionId || null)
        this.$refs.resourceGrid.refresh()
      },

      getProductTemplateDetail () {
        const constraints = { productTemplateId: this.productTemplateId }

        if (this.selectedSection.productTemplateSectionId) {
          constraints.productTemplateSectionId = this.selectedSection.productTemplateSectionId
        }

        return this.productTemplateDetailResource.query(constraints)
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.productTemplateId = this.productTemplateId
          ensureNumericOrNull(payload, 'orderNo')
        }
        return payload
      },
    },
  }
</script>
